import { render, staticRenderFns } from "./sign_sward_set.vue?vue&type=template&id=654f513a&scoped=true"
import script from "./sign_sward_set.vue?vue&type=script&lang=ts"
export * from "./sign_sward_set.vue?vue&type=script&lang=ts"
import style0 from "./sign_sward_set.vue?vue&type=style&index=0&id=654f513a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654f513a",
  null
  
)

export default component.exports